import React from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer.js';
import Details from '../../Components/Details/Details';

const ServiceDetails = () => {
    return (
        <>
            <Header/>
            <Details/>
            <Footer/>
        </>
    );
};

export default ServiceDetails;